export default {
  getPluginList: {
    method: 'get',
    url: 'plugin'
  },
  revisePlugin: {
    method: 'put',
    url: 'plugin'
  },
  deletePlugin: {
    method: 'delete',
    url: 'plugin'
  },
  addPlugin: {
    method: 'post',
    url: 'plugin'
  },
  upgradePlugin: {
    method: 'post',
    url: 'plugin/upgrade'
  }
}
